import React from 'react';
import {Card, CardBody, CardFooter, CardHeader,Button} from 'reactstrap';

let control=[
    {label:"Salad",type:'salad'},
    {label:"Cheese",type:'cheese'},
    {label:"Meat",type:'meat'},
]

let BurgerBuild=props=>{
    return(
        <div className="d-flex mb-2">
            <div className="mr-auto ml-5 font-weight-bold">{props.type.label}</div>
            <button className="btn btn-danger mr-4" onClick={props.remove}>Less</button>
            <button className="btn btn-success " onClick={props.added} >More</button>
            
        </div>
    )
}

let Controls=props=>{
    return(
        <div className="container mt-0 mb-5 p-5">
            <Card>
                <CardHeader className="heading font-weight-bold h3">Add Ingredient</CardHeader>
                <CardBody>
                    {
                        control.map(item=>{
                            return <BurgerBuild type={item} 
                            added={()=>props.ingredientAdd(item.type)} 
                            remove={()=>props.ingredientRemove(item.type)}
                            key={Math.random()} />
                        })
                    }
                </CardBody>
                <CardFooter>Price : <strong>{props.price}</strong> BDT</CardFooter>
            </Card>
            <div className="d-block ">
                <Button 
                    className="w-100 mt-2 m-0 text-center heading" 
                    disabled={!props.purchase} 
                    onClick={props.order}>
                    Order Now
                </Button>
            </div>
        </div>
    )
}

export default Controls;